module.exports = __webpack_public_path__ + "static/img/PastedGraphic-5@2x.18bb7e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/PastedGraphic-5@2x.png
// module id = Ch23
// module chunks = 1